export const DISCOUNT_MODE = {
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
};

export const DISCOUNT_DURATION = {
  ONCE: 'ONCE',
  FOREVER: 'FOREVER',
  REPEATING: 'REPEATING',
};

/**
 * Return the discount price using an AccountPromoCode.
 *
 * @param {Number} price The item price.
 * @param {Object} accountPromoCode The AccountPromoCode to apply.
 *
 * @returns {Number} The discount price.
 */
export const getDiscountPrice = (price, accountPromoCode) => {
  if (!accountPromoCode?.discount) {
    return price;
  }
  if (accountPromoCode.discount.mode === DISCOUNT_MODE.AMOUNT) {
    return price - accountPromoCode.discount.value;
  }

  return Math.round(price * ((100 - accountPromoCode.discount.value) / 100));
};
